export default __webpack_public_path__ + "static/media/esperenza6.0dc094d5.jpg";